const home_page = document.getElementById("home-page");

//@ Only run if user on home page
if (home_page) {
  // const swiper = home_page.querySelector("swiper-container");

  // console.log(swiper);

  //# Initialise offerings swiper
  init_offerings_swiper();
  function init_offerings_swiper() {
    //$ Assign the swiper container element
    const swiperEl = home_page.querySelector("swiper-container.offerings");

    //$ Exit function if the swiper element can't be found
    if (!swiperEl) {
      return;
    }

    //$ Define Custom Nav buttons
    const buttons = {
      prev: home_page.querySelector(".prev"),
      next: home_page.querySelector(".next"),
    };

    // console.log(buttons);

    const params = {
      // slidesPerView: 3,
      loop: true,
      spaceBetween: 20,
      // effect: "fade",
      // speed: 500,
      navigation: {
        disabledClass: "disabled",
        prevEl: home_page.querySelector(".prev"),
        nextEl: home_page.querySelector(".next"),
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        1000: {
          slidesPerView: 2,
        },
        1300: {
          slidesPerView: 3,
        },
      },
      on: {
        init() {},
      },
    };

    //$ assign all parameters to Swiper element
    Object.assign(swiperEl, params);

    //$ initialize it
    swiperEl.initialize();
  }


  //# Observe the swiper container to add animation to slides
  observe_element(
    "swiper-container.offerings",
    false,
    "-10%"
  );
}
